import React from 'react';
import ReportTechnicalDifficultiesSuccess from './ReportTechnicalDifficultiesSuccess';
import ReportTechnicalDifficultiesFailure from './ReportTechnicalDifficultiesFailure';

const ReportTechnicalDifficultiesMessage = ({
  reloadRecording,
  sendFeedbackError,
}) => {
  return sendFeedbackError ? (
    <ReportTechnicalDifficultiesFailure reloadRecording={reloadRecording} />
  ) : (
    <ReportTechnicalDifficultiesSuccess />
  );
};

export default ReportTechnicalDifficultiesMessage;
